/**
 * @generated SignedSource<<90fd0024d71a1afa828db641e60dbe05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueDashboardCustomViewPageCurrentViewFragment$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderCurrentViewFragment">;
  readonly " $fragmentType": "IssueDashboardCustomViewPageCurrentViewFragment";
};
export type IssueDashboardCustomViewPageCurrentViewFragment$key = {
  readonly " $data"?: IssueDashboardCustomViewPageCurrentViewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueDashboardCustomViewPageCurrentViewFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueDashboardCustomViewPageCurrentViewFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderCurrentViewFragment"
    }
  ],
  "type": "Shortcutable",
  "abstractKey": "__isShortcutable"
};

(node as any).hash = "ae67b5966e39324c4855cfe2a9cdd9e2";

export default node;
